import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Divider, FormControlLabel, Popover, Stack, Typography } from "@mui/material";
import { Checkbox, IconButtonVariant } from "@styleguide";
import { useMenuSelectChallenges } from "./logic";

export interface IMenuSelectChallengesProps {
  open: boolean;
  offer: ISocialOffer;
  anchorEl: HTMLElement | null;
  type?: "propose" | "addToFavorite";
  onConfirm: (selectedChallenges: IChallenge[]) => void | Promise<void>;
  onClose: () => void;
}

export const MenuSelectChallenges = ({
  open,
  offer,
  anchorEl,
  type = "propose",
  onConfirm,
  onClose,
}: IMenuSelectChallengesProps) => {
  const { challengesOptions, selectedChallenges, setSelectedChallenges, handleSelect, isSelected } =
    useMenuSelectChallenges(open, offer);

  const titleText =
    type === "addToFavorite"
      ? "Mettre en favori pour la/les thématiques suivantes :"
      : "Pour la/ les thématiques suivantes :";

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{ maxHeight: 251, zIndex: 1500 }}
      slotProps={{
        paper: {
          sx: (theme) => ({ zIndex: 1201, borderRadius: 0, border: `1px solid ${theme.palette.border.main}` }),
        },
      }}
    >
      <Stack
        sx={{
          paddingX: 2,
          paddingTop: 2,
          paddingBottom: 1,
          gap: 1,
          alignItems: "start",
        }}
      >
        <Typography variant="body1">{titleText}</Typography>
        {challengesOptions.map((challenge) => (
          <FormControlLabel
            key={challenge._id}
            checked={isSelected(challenge)}
            onChange={() => handleSelect(challenge)}
            control={<Checkbox size="small" sx={{ p: 0, paddingRight: 1 }} />}
            label={challenge.name}
            sx={{ p: 0, m: 0, width: "100%" }}
          />
        ))}
      </Stack>
      <Divider sx={{ marginTop: "0 !important", marginX: 2 }} />
      <Stack
        direction="row"
        sx={{
          justifyContent: "end",
          gap: 1,
          paddingX: 2,
          paddingTop: 1,
          paddingBottom: 2,
        }}
      >
        <IconButtonVariant onClick={onClose} variant="elevated">
          <CloseIcon fontSize="small" color="primary" />
        </IconButtonVariant>
        <IconButtonVariant
          onClick={() => {
            void onConfirm(selectedChallenges);
            onClose();
            setSelectedChallenges([]);
          }}
          variant="elevated"
        >
          <CheckIcon fontSize="small" color="success" />
        </IconButtonVariant>
      </Stack>
    </Popover>
  );
};
